import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  linkHref?: string;
  linkLabel?: string;
  icon?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  linkHref,
  linkLabel = "查看全部",
  icon,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        {icon && (
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
            <i className={icon} />
          </span>
        )}
        <div>
          <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
        </div>
      </div>
      {linkHref && (
        <Link
          to={linkHref}
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-accent-600 transition-colors hover:text-accent-700 md:flex"
        >
          {linkLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base" />
          </span>
        </Link>
      )}
    </div>
  );
}